/**
 * The model representing the result
 * @class
 */
Selector.Model.Result = Backbone.Model.extend(
/** @lends Selector.Model.Result# */
{

    fetchProduct: function(){
        var _this = this;
        //only do this for first result
        if (this.get("results") !== null && this.get("results").length === 1) {

            var result = this.get("results")[0];

            if (result.PRODUCTID != 0 && typeof result.PRODUCTID != "undefined") { 
                return fetch(ele.uri.buildUrl("productdata", {productId: result.PRODUCTID, ajax: 1}))
                    .then(function(response) {
                        return response.json();
                    })
                    .then(function(product) {
                        $.extend(result, product);
                        var results = _this.get("results");
                        results[0] = result;
                        _this.set({results: results});
                        return product;
                    })
                    .catch(function(error){
                        console.error(error);
                    });
            }
        }
        return null;
    }
	
});